import React, { useState } from "react";

const NationalitySection = ({ nationality, setNationality }) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleNationalityChange = (event) => {
    setNationality(event.target.value);
  };

  const handleSaveNationality = () => {
    //console.log("Saving nationality:", nationality);
    setIsEditing(false);
    // Call API to save nationality
  };

  const handleCancelNationality = () => {
    //console.log("Canceling nationality change");
    // Reset the state to original value
    setNationality("United States");
    setIsEditing(false);
  };

  return (
    <div className="mb-4">
      <h2 className="font-bold text-gray-700 text-lg mb-2">Nationality</h2>
      <p className="text-gray-500 text-sm">{nationality}</p>
      <button
        className="text-blue-500 hover:text-blue-700 text-sm"
        onClick={() => {
          setIsEditing(true);
        }}
      >
        Edit
      </button>
      {/* Edit mode */}
      {isEditing && (
        <div className="mt-2">
          <select
            className="w-full border-gray-300 rounded-md shadow-sm mb-2"
            value={nationality}
            onChange={handleNationalityChange}
          >
            <option value="India">India</option>
            <option value="United States">United States</option>
            <option value="Canada">Canada</option>
            <option value="Mexico">Mexico</option>
            <option value="UK">UK</option>
            {/* Add more countries here */}
          </select>
          <button
            className="text-white bg-black hover:scale-[1.05] transition-all font-bold py-2 px-4 rounded mr-2"
            onClick={handleSaveNationality}
          >
            Save
          </button>
          <button
            className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
            onClick={handleCancelNationality}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};

export default NationalitySection;
